import React from "react";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";

/**
 * Reusable component for displaying information in a grid layout
 * @param {Array} data - Array of objects with { label, value } structure
 * @param {Object} customStyles - Optional custom styles to override defaults
 */
function InfoDisplayGrid({ data = [], customStyles = {} }) {
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Grid container spacing={1}>
      {data.map((item, index) => (
        <React.Fragment key={index}>
          <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Box sx={{ ...styles.box_left_align, ...customStyles.labelBox }}>
              <Typography sx={{ ...styles.grn_supplier_text, ...customStyles.label }}>
                {item.label}
              </Typography>
            </Box>
          </Grid>
          <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Box sx={{ ...styles.box_left_align, ...customStyles.valueBox }}>
              <Typography sx={{ ...styles.grn_supplier_title, ...customStyles.value }}>
                {item.value || "-"}
              </Typography>
            </Box>
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
}

export default InfoDisplayGrid;
